import type { PropsWithChildren } from "react";
import { Link } from "react-router-dom-v5-compat";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api";
import { useLinkToHotel } from "@tenant/hotels";
import clsx from "clsx";
import defaultStyles from "./LinkToHotel.module.scss";

export type LinkToHotelProps = {
  hotel: Lodging;
  className?: string;
  openSamePage?: boolean;
  target?: string;
  onTokenStore?: () => void;
  onClick?: () => void;
};

export const LinkToHotel = ({
  children,
  className,
  onClick,
  ...props
}: PropsWithChildren<LinkToHotelProps>) => {
  const styles = useHotelsStyles(CoreHotelsComponent.HotelLink, defaultStyles);
  const [block] = useModuleBEM(styles, CoreHotelsComponent.HotelLink);

  const { context, handlers } = useLinkToHotel(props);

  return (
    <Link
      to={context.target}
      className={clsx(block, className)}
      // All of these handlers are needed to fully ensure that the token is
      // stored, regardless of how the user interacts with the link.
      // Considered use cases are:
      // - Clicking the link
      // - Tabbing to the link and pressing enter
      // - Right-clicking the link and opening in a new tab
      // - Middle-clicking the link
      onFocus={handlers.storeHotelToken}
      onMouseOver={handlers.storeHotelToken}
      onTouchStart={handlers.storeHotelToken}
      onClick={onClick}
      {...context.linkProps}
    >
      {children}
    </Link>
  );
};

export default LinkToHotel;
